/* eslint-disable no-unused-vars */
import React from 'react'

export default function AllServices() {
  return (
    <div>AllServices</div>
  )
}
